import api from './api';
import { fallbackOrganizationContact } from '../utils/organizationContactDefaults';

const CACHE_MS = 60_000;
let cached = null;
let cachedAt = 0;
let inflight = null;

const normalizeOrganization = (payload) => {
  const fallback = fallbackOrganizationContact();
  if (!payload?.entreprise || !payload?.support) return fallback;

  const normalizeBlock = (slice, fb) => ({
    phone: slice?.phone || fb.phone,
    email: slice?.email || fb.email,
    horaires: slice?.horaires || fb.horaires,
    telHref: slice?.telHref || fb.telHref,
    mailtoHref: slice?.mailtoHref || fb.mailtoHref
  });

  return {
    entreprise: {
      nom: payload.entreprise.nom || fallback.entreprise.nom,
      ...normalizeBlock(payload.entreprise, fallback.entreprise)
    },
    secretariat: normalizeBlock(payload.secretariat, fallback.secretariat),
    support: normalizeBlock(payload.support, fallback.support),
    dpo: {
      email: payload.dpo?.email || fallback.dpo.email,
      courrier: payload.dpo?.courrier || fallback.dpo.courrier,
      mailtoHref: payload.dpo?.mailtoHref || fallback.dpo.mailtoHref
    }
  };
};

export function invalidateOrganizationContactCache() {
  cached = null;
  cachedAt = 0;
}

export async function fetchOrganizationContact({ publicAccess = false, force = false } = {}) {
  const now = Date.now();
  if (!force && cached && now - cachedAt < CACHE_MS) {
    return cached;
  }
  if (inflight) return inflight;

  const path = publicAccess ? '/public/organization-contact' : '/organization-contact';
  inflight = api
    .get(path)
    .then((response) => {
      const organization = normalizeOrganization(response?.data?.organization);
      cached = organization;
      cachedAt = Date.now();
      return organization;
    })
    .catch(() => fallbackOrganizationContact())
    .finally(() => {
      inflight = null;
    });

  return inflight;
}

export async function saveOrganizationContact(payload) {
  const response = await api.put('/organization-contact', payload);
  const organization = normalizeOrganization(response?.data?.organization);
  cached = organization;
  cachedAt = Date.now();
  return organization;
}
